document.addEventListener('DOMContentLoaded', () => {
    const ucScript = document.getElementById("usercentrics-cmp") as HTMLScriptElement | null;

    if (ucScript) {
        if (window.__ucCmp) {
            void initCrossDomainLinks();
        } else {
            ucScript.addEventListener("load", () => {
                void initCrossDomainLinks();
            });
        }
    }
});

async function initCrossDomainLinks(): Promise<void> {
    const crossDomainLinks = document.querySelectorAll<HTMLAnchorElement>('a[data-cross-domain]');
    for (const crossDomainLink of crossDomainLinks) {
        const originalUrl: string = crossDomainLink.href;
        const targetUrl = new URL(originalUrl, window.location.origin);

        if (targetUrl.hostname !== window.location.hostname) {
            const controllerId = await window.__ucCmp.getControllerId() as string;
            targetUrl.searchParams.set('usercentrics-controller-id', controllerId);

            crossDomainLink.href = targetUrl.toString();
        }
    }
}
